import { Directive, Input } from '@angular/core';
import { NumberInput, toNumber } from '@ngx-simple/core/coercion';
import { SimSelectionDirective } from '@ngx-simple/simple-ui/selection';

/**
 * Applies `mat-selected` class and `aria-selected` to an element.
 *
 * Must be used within a parent `MatSelection` directive.
 * Must be provided with the value. The index is required if `trackBy` is used on the `CdkSelection`
 * directive.
 */
@Directive({
  selector: '[simRowSelection]',
  host: {
    '[class.mat-selected]': '_selection.isSelected(this.value, this.index)',
    '[attr.aria-selected]': '_selection.isSelected(this.value, this.index)'
  }
})
export class SimRowSelectionDirective<T> {
  static ngAcceptInputType_index: NumberInput;

  /** 与行关联的值 */
  @Input('simRowSelectionValue') value: T;

  /** 列表中值的索引。与`trackBy`一起使用时需要 */
  @Input('simRowSelectionIndex')
  get index(): number | undefined {
    return this._index;
  }
  set index(index: number | undefined) {
    this._index = toNumber(index);
  }
  private _index: number;

  constructor(readonly _selection: SimSelectionDirective<T>) {}
}
